import React, { useState } from 'react';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { 
  Box, 
  Container, 
  FormControl, 
  MenuItem, 
  Select, 
  Typography, 
  Card, 
  CardContent, 
  Divider,
  InputAdornment,
  styled
} from '@mui/material';
import { 
  AttachMoney, 
  Person, 
  Business, 
  Description, 
  Phone, 
  Security 
} from '@mui/icons-material';
import { url } from '../utils/constants';
import { useNavigate } from 'react-router-dom';
import { LoaderOverlay } from '../utils/components';
import { useAuth } from '../../contexts/AuthContext';


//const paymentTypes = [{ value: 'pix', label: 'Pix' }, { value: 'cartao', label: 'Cartão de crédito' }]; // [2]

// Styled Components
const ModernButton = styled(Button)(({ theme }) => ({
  background: 'linear-gradient(135deg, #1976D2 0%, #1565C0 100%)',
  borderRadius: 12,
  padding: '12px 24px',
  fontSize: '1rem',
  fontWeight: 600,
  textTransform: 'none',
  boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
  '&:hover': {
    background: 'linear-gradient(135deg, #1565C0 0%, #0D47A1 100%)',
    boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
    transform: 'translateY(-2px)',
  },
  transition: 'all 0.3s ease',
}));

const ModernTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 12,
    backgroundColor: '#FAFAFA',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1976D2',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1976D2',
      borderWidth: 2,
    },
  },
  '& .MuiInputLabel-root': {
    color: '#666',
    '&.Mui-focused': {
      color: '#1976D2',
    },
  },
}));

const ModernSelect = styled(Select)(({ theme }) => ({
  borderRadius: 12,
  backgroundColor: '#FAFAFA',
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#1976D2',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#1976D2',
    borderWidth: 2,
  },
}));

const masks = {
    '+55': { name: 'Brasil', mask: '(xx) xxxxx-xxxx' },
    '+54': { name: 'Argentina', mask: '(x) xxxx xx-xxxx' },
    '+595': { name: 'Paraguay', mask: '(xxx) xxx-xxx' },
    '+1': { name: 'EUA', mask: '(xxx) xxx-xxxx' }
    // Adicione outras máscaras conforme necessário
};

const PagamentoMercadoPago = ({ usePageTitle }) => {
    usePageTitle('PixTick | Gerar Cobrança');
    const navigate = useNavigate();
    const { isLoggedIn, logout, loading: authLoading } = useAuth();
    //const [imgqrcode, setImgqrcode] = useState(''); // [1]
    const [phone, setPhone] = useState("");
    const [paymentType, setPaymentType] = useState("pix"); // [2]
    const [ddi, setDdi] = useState("+55");
    const [error, setError] = useState("");
    const [inputValue, setInputValue] = useState('');
    const [descricao, setDescricao] = useState('');
    const [nome, setNome] = useState('');
    const [sobrenome, setSobrenome] = useState('');
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        // Aguardar a verificação de autenticação ser concluída
        if (authLoading) {
            return;
        }

        // Redirecionar apenas se não estiver logado E a verificação foi concluída
        if (!isLoggedIn) {
            navigate('/signin');
        }
    }, [isLoggedIn, authLoading, navigate]);

    const handleInputChange = (event) => {
        const value = event.target.value;
        let formattedValue = '';

        // Remover caracteres não numéricos
        const numericValue = value.replace(/\D/g, '');

        // Obter os centavos (últimos dois dígitos)
        const cents = numericValue.slice(-2);

        // Obter os reais (todos os dígitos exceto os últimos dois)
        const dollars = numericValue.slice(0, -2);

        // Formatar os reais com separadores de milhares
        for (let i = 0; i < dollars.length; i++) {
            formattedValue += dollars[i];
            if ((dollars.length - i - 1) % 3 === 0 && i !== dollars.length - 1) {
                formattedValue += '.';
            }
        }

        // Adicionar os centavos
        formattedValue += ',' + cents;

        setInputValue(formattedValue);
    };

    const handleDescricaoChange = (event) => {
        const { value } = event.target;
        setDescricao(value);
    }
    const handleNomeChange = (event) => {
        const { value } = event.target;
        setNome(value);
    }
    const handleSobrenomeChange = (event) => {
        const { value } = event.target;
        setSobrenome(value);
    }

    const normalizeInput = (value, ddi) => {
        if (!value) return value;
        const currentValue = value.replace(/[^\d]/g, '');

        // Obter a máscara correspondente ao DDI selecionado
        const mask = masks[ddi].mask;
        if (!mask) {
            // Se não houver uma máscara correspondente, retornar o valor atual sem formatação
            return currentValue;
        }

        let formattedValue = '';
        let maskIndex = 0;
        for (let i = 0; i < mask.length && maskIndex < currentValue.length; i++) {
            if (mask[i] === 'x') {
                // Se o caractere na máscara for 'x', adicionar o próximo dígito do valor atual
                formattedValue += currentValue[maskIndex];
                maskIndex++;
            } else {
                // Se o caractere na máscara não for 'x', adicionar o próprio caractere
                formattedValue += mask[i];
            }
        }
        return formattedValue;
    };

    const handleChange = (event) => {
        const { value } = event.target;
        //setPhone(value);
        setPhone(normalizeInput(value, ddi));

    };

    const handleDdiChange = (event) => {
        const { value } = event.target;
        setDdi(value);
        //handleReset();
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            if (loading) return;
            const token = localStorage.getItem('token');

            console.log('🔐 Token para pagamento:', token ? 'Presente' : 'Ausente');
            console.log('🔍 isLoggedIn no submit:', isLoggedIn);

            const headers = {
                Authorization: `Bearer ${token}`
            };
            const body = {
                numero: ((ddi + phone).replace(/[()\s+-]/g, "")),
                valor: inputValue,
                descricao: descricao,
                nomeCompleto: nome + ' ' + sobrenome,
                paymentType: paymentType

            };

            if (body.numero.length < 10 || body.valor === '' || body.descricao === '' || body.nomeCompleto === '') {
                setError('Preencha todos os campos');
                return;

            }

            setLoading(true);
            const { data } = await axios.post(url + '/api/v1/pagamento', body, { headers });

            console.log('✅ Pagamento criado com sucesso:', data);
            console.log('ID da transação:', data.id);

            setLoading(false);

            // Navegar apenas se o pagamento foi criado com sucesso
            if (data && data.id) {
                console.log('🔄 Navegando para relatório:', data.id);
                navigate('/relatorio-pagamento/' + data.id);
            } else {
                console.log('❌ ID da transação não encontrado, navegando para lista geral');
                navigate('/relatorio-pagamento');
            }

        } catch (error) {
            console.error('💥 Erro ao gerar pagamento:', error);
            console.error('Status:', error.response?.status);
            console.error('Data:', error.response?.data);
            console.error('Headers:', error.response?.headers);

            setError('Erro ao gerar qr code, tente novamente!');
            setLoading(false);
        }

    };



    return (
        <Box 
            sx={{ 
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: { xs: 2, md: 4 }
            }}
        >
            <LoaderOverlay loading={authLoading || loading} color='green' />
            
            <Container maxWidth="sm">
                <Card 
                    elevation={8}
                    sx={{ 
                        borderRadius: 4,
                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                        backdropFilter: 'blur(10px)',
                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                        overflow: 'hidden'
                    }}
                >
                    <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                        <Box component="form" onSubmit={handleSubmit} noValidate>
                            {/* Header */}
                            <Box sx={{ textAlign: 'center', mb: 4 }}>
                                <Typography 
                                    variant="h4" 
                                    sx={{ 
                                        fontWeight: 700,
                                        color: '#1976D2',
                                        mb: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 1
                                    }}
                                >
                                    <AttachMoney sx={{ fontSize: '2rem' }} />
                                    Gerar Link
                                </Typography>
                                <Typography variant="body1" color="text.secondary">
                                    Crie um link de pagamento personalizado
                                </Typography>
                            </Box>

                            <Divider sx={{ mb: 3 }} />

                            {/* Valor */}
                            <Box sx={{ mb: 3 }}>
                                <ModernTextField
                                    required
                                    fullWidth
                                    label="Valor do pagamento"
                                    value={inputValue}
                                    onChange={handleInputChange}
                                    placeholder="0,00"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AttachMoney color="action" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>

                            {/* Nome e Sobrenome */}
                            <Box sx={{ 
                                display: 'flex', 
                                gap: 2, 
                                mb: 3,
                                flexDirection: { xs: 'column', sm: 'row' }
                            }}>
                                <ModernTextField
                                    required
                                    fullWidth
                                    label="Nome"
                                    value={nome}
                                    onChange={handleNomeChange}
                                    placeholder="Ex: João"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Person color="action" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <ModernTextField
                                    required
                                    fullWidth
                                    label="Sobrenome"
                                    value={sobrenome}
                                    onChange={handleSobrenomeChange}
                                    placeholder="Ex: da Silva"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Business color="action" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>

                            {/* Descrição */}
                            <Box sx={{ mb: 3 }}>
                                <ModernTextField
                                    required
                                    fullWidth
                                    label="Descrição do pagamento"
                                    value={descricao}
                                    onChange={handleDescricaoChange}
                                    placeholder="Ex: Pagamento de serviços"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Description color="action" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>

                            {/* Telefone */}
                            <Box sx={{ mb: 4 }}>
                                <Typography variant="subtitle2" sx={{ mb: 1, color: '#666' }}>
                                    Telefone de contato
                                </Typography>
                                <Box sx={{ 
                                    display: 'flex', 
                                    gap: 2,
                                    flexDirection: { xs: 'column', sm: 'row' }
                                }}>
                                    <FormControl sx={{ minWidth: { xs: '100%', sm: 150 } }}>
                                        <ModernSelect
                                            value={ddi}
                                            onChange={handleDdiChange}
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <Security color="action" />
                                                </InputAdornment>
                                            }
                                        >
                                            {Object.keys(masks).map((countryCode) => (
                                                <MenuItem key={countryCode} value={countryCode}>
                                                    {`${countryCode} - ${masks[countryCode].name}`}
                                                </MenuItem>
                                            ))}
                                        </ModernSelect>
                                    </FormControl>
                                    <ModernTextField
                                        required
                                        fullWidth
                                        label="Número de telefone"
                                        type="tel"
                                        placeholder={masks[ddi].mask}
                                        value={phone}
                                        name="phoneNumber"
                                        onChange={handleChange}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Phone color="action" />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                                {error && (
                                    <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                                        {error}
                                    </Typography>
                                )}
                            </Box>

                            {/* Botão de envio */}
                            <ModernButton 
                                fullWidth 
                                type="submit" 
                                size="large"
                                disabled={loading}
                            >
                                {loading ? 'Gerando...' : 'Gerar Link de Pagamento'}
                            </ModernButton>
                        </Box>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    );
};

export default PagamentoMercadoPago;
